import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function ModifierFacturationPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { utilisateur } = useAuth();
  const [tarifs, setTarifs] = useState({});
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get(`/facturation/${id}`).then(r => {
      const f = r.data;
      setForm({
        abattoir_id: f.abattoir_id,
        session_label: f.session_label,
        type_jour: f.type_jour,
        bovins_nbr: f.bovins_nbr||0, bovins_poids: f.bovins_poids||0,
        bovins_stab_nuit: f.bovins_stab_nuit||0,
        ovins_nbr: f.ovins_nbr||0, ovins_poids: f.ovins_poids||0,
        caprins_nbr: f.caprins_nbr||0, caprins_poids: f.caprins_poids||0,
        porcins_nbr: f.porcins_nbr||0, porcins_poids: f.porcins_poids||0,
        vf_poids: f.vf_poids||0, vf_tarif: f.vf_tarif||0,
        stockage_frigo: f.stockage_frigo||0,
        stockage_abattoir: f.stockage_abattoir||0,
        location: f.location||0, timbres: f.timbres||0, tickets: f.tickets||0,
        bon_sortie_numero: f.bon_sortie_numero||'',
        bon_sortie_nombre: f.bon_sortie_nombre||0,
        observations: f.observations||'',
        statut: f.statut,
        abattoir_nom: f.abattoir_nom,
        date_facturation: f.date_facturation,
      });
      return api.get(`/facturation/tarifs/${f.abattoir_id}`);
    }).then(r => setTarifs(r.data))
    .catch(() => setMessage({ type: 'erreur', texte: 'Erreur chargement.' }));
  }, [id]);

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const t = (espece) => form ? tarifs[`${espece}_${form.type_jour}`] || {} : {};

  const calc = form ? {
    bovins_stab_jour: (form.bovins_nbr||0) * (t('bovin').tarif_stabulation||0),
    bovins_abattage:  (form.bovins_poids||0) * (t('bovin').tarif_abattage||0),
    bovins_ressuage:  (form.bovins_poids||0) * (t('bovin').tarif_ressuage||0),
    ovins_stab:       (form.ovins_nbr||0) * (t('ovin').tarif_stabulation||0),
    ovins_abattage:   (form.ovins_poids||0) * (t('ovin').tarif_abattage||0),
    caprins_stab:     (form.caprins_nbr||0) * (t('caprin').tarif_stabulation||0),
    caprins_abattage: (form.caprins_poids||0) * (t('caprin').tarif_abattage||0),
    porcins_stab:     (form.porcins_nbr||0) * (t('porcin').tarif_stabulation||0),
    porcins_abattage: (form.porcins_poids||0) * (t('porcin').tarif_abattage||0),
  } : {};

  const calc_vf = form ? (parseFloat(form.vf_poids)||0) * (parseFloat(form.vf_tarif)||0) : 0;
  const bovins_stab_total = form ? calc.bovins_stab_jour + parseFloat(form.bovins_stab_nuit||0) : 0;
  const totalBovins = bovins_stab_total + (calc.bovins_abattage||0) + (calc.bovins_ressuage||0);
  const totalOvins = (calc.ovins_stab||0) + (calc.ovins_abattage||0);
  const totalCaprins = (calc.caprins_stab||0) + (calc.caprins_abattage||0);
  const totalPorcins = (calc.porcins_stab||0) + (calc.porcins_abattage||0);
  const totalAbattoir = totalBovins + totalOvins + totalCaprins + totalPorcins;
  const totalAnnexes = form ? parseFloat(form.stockage_frigo||0)+parseFloat(form.stockage_abattoir||0)+parseFloat(form.location||0)+parseFloat(form.timbres||0)+parseFloat(form.tickets||0) : 0;
  const totalGeneral = totalAbattoir + calc_vf + totalAnnexes;
  const fmt = (n) => Math.round(n).toLocaleString('fr-FR');

  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true);
    try {
      await api.put(`/facturation/${id}`, form);
      setMessage({ type: 'succes', texte: '✅ Facturation modifiée !' });
      setTimeout(() => navigate('/facturation/liste'), 1500);
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur.' });
    } finally { setChargement(false); }
  };

  if (!form) return <div style={{ padding: 40, textAlign: 'center' }}>⏳ Chargement...</div>;

  const estSigne = form.statut === 'SIGNE';
  const peutModifier = !estSigne || ['admin'].includes(utilisateur?.role);

  const C = {
    primary: '#2E7D32', primaryDark: '#1B5E20',
    border: '#E0E0E0', light: '#F4F6F9',
    green50: '#F1F8F2', green100: '#E8F5E9',
  };

  const S = {
    page: { minHeight: '100vh', background: C.light },
    topbar: { height: 52, background: '#fff', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 28px', position: 'sticky', top: 0, zIndex: 100 },
    breadcrumb: { fontSize: 13, color: '#9E9E9E', display: 'flex', alignItems: 'center', gap: 6 },
    breadcrumbActive: { color: '#212121', fontWeight: 600 },
    container: { maxWidth: 1000, margin: '24px auto', padding: '0 20px' },
    carte: { background: 'white', borderRadius: 12, marginBottom: 20, border: `1px solid ${C.border}`, overflow: 'hidden' },
    titreCarte: () => ({ background: estSigne ? '#B71C1C' : C.primary, color: '#fff', padding: '10px 16px', fontSize: 13, fontWeight: 700 }),
    carteBody: { padding: '20px 24px' },
    grille4: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 12 },
    grille3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 },
    label: { display: 'block', fontSize: 12, color: '#616161', marginBottom: 4, fontWeight: 600 },
    input: { width: '100%', padding: '9px 12px', border: `1.5px solid ${C.border}`, borderRadius: 8, fontSize: 14, boxSizing: 'border-box' },
    inputLecture: { width: '100%', padding: '9px 12px', border: '1.5px solid #A5D6A7', borderRadius: 8, fontSize: 14, background: C.green50, fontWeight: 700, color: C.primaryDark, boxSizing: 'border-box' },
    inputNuit: { width: '100%', padding: '9px 12px', border: '1.5px solid #FFCC80', borderRadius: 8, fontSize: 14, background: '#FFFDE7', boxSizing: 'border-box' },
    totalLigne: { display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: C.green50, borderRadius: 6, marginTop: 12, fontWeight: 700, color: C.primaryDark },
    totalGeneral: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: C.green100, border: '1.5px solid #A5D6A7', borderRadius: 8, fontSize: 16, fontWeight: 700, color: C.primaryDark, marginTop: 15 },
    alerte: (tp) => ({ padding: '12px 16px', borderRadius: 8, marginBottom: 15, background: tp==='succes'?C.green100:'#FFEBEE', color: tp==='succes'?C.primaryDark:'#C62828', border: `1px solid ${tp==='succes'?'#A5D6A7':'#EF9A9A'}`, fontSize: 14 }),
    btnRetour: { background: 'transparent', border: 'none', color: '#757575', fontSize: 13, cursor: 'pointer' },
    badgeStatut: { display:'inline-block', padding:'3px 12px', borderRadius:20, fontSize:12, fontWeight:700, marginLeft:10, background: estSigne?'#FFEBEE':'#FFF8E1', color: estSigne?'#C62828':'#E65100', border: `1px solid ${estSigne?'#EF9A9A':'#FFCC80'}` },
  };

  return (
    <div style={S.page}>
      <div style={S.topbar}>
        <div style={S.breadcrumb}>
          <span>Facturation</span>
          <span>›</span>
          <span>Liste</span>
          <span>›</span>
          <span style={S.breadcrumbActive}>{estSigne ? 'Correction' : 'Modification'} N°{id}</span>
          <span style={S.badgeStatut}>{form.statut}</span>
        </div>
        <button style={S.btnRetour} onClick={() => navigate('/facturation/liste')}>← Retour à la liste</button>
      </div>
      <div style={S.container}>
        {estSigne && (
          <div style={{ ...S.alerte('erreur'), marginBottom: 16 }}>
            ⚠️ Cette facturation est <strong>SIGNÉE</strong>. Seul l'admin ou le responsable de facturation peut la modifier.
          </div>
        )}

        {message.texte && <div style={S.alerte(message.type)}>{message.texte}</div>}

        <div style={{ background: '#fff', borderRadius: 12, border: `1px solid ${C.border}`, padding: '12px 20px', marginBottom: 16, fontSize: 14 }}>
          <strong>📋 {form.abattoir_nom}</strong> — {new Date(form.date_facturation).toLocaleDateString('fr-FR')} — Session : {form.session_label}
        </div>

        {!peutModifier ? (
          <div style={S.alerte('erreur')}>❌ Vous n'avez pas les droits pour modifier une facturation signée.</div>
        ) : (
          <form onSubmit={soumettre}>
            <div style={S.carte}>
              <div style={S.titreCarte()}>📋 Informations</div>
              <div style={S.carteBody}><div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:15 }}>
                <div>
                  <label style={S.label}>Type de jour</label>
                  <select style={S.input} name="type_jour" value={form.type_jour} onChange={champ}>
                    <option value="STANDARD">STANDARD</option>
                    <option value="SPECIAL">SPECIAL</option>
                  </select>
                </div>
                <div>
                  <label style={S.label}>Session</label>
                  <select style={S.input} name="session_label" value={form.session_label} onChange={champ}>
                    <option value="PRINCIPALE">Principale</option>
                    <option value="MATIN">Matin</option>
                    <option value="SOIR">Soir</option>
                    <option value="SPECIALE">Spéciale</option>
                  </select>
                </div>
              </div>
              </div>
            </div>

            {/* BOVINS */}
            <div style={S.carte}>
              <div style={S.titreCarte()}>🐄 BOVINS — {form.type_jour}: Stab {t('bovin').tarif_stabulation} F/tête | Abattage {t('bovin').tarif_abattage} F/kg | Ressuage {t('bovin').tarif_ressuage} F/kg</div>
              <div style={S.carteBody}><div style={S.grille4}>
                <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="bovins_nbr" value={form.bovins_nbr} onChange={champ} /></div>
                <div><label style={S.label}>Poids (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="bovins_poids" value={form.bovins_poids} onChange={champ} /></div>
                <div><label style={S.label}>Stab nuit (FCFA)</label><input style={S.inputNuit} type="number" min="0" name="bovins_stab_nuit" value={form.bovins_stab_nuit} onChange={champ} /></div>
                <div><label style={S.label}>Stab jour (auto)</label><input style={S.inputLecture} value={fmt(calc.bovins_stab_jour)} readOnly /></div>
                <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.bovins_abattage)} readOnly /></div>
                <div><label style={S.label}>Ressuage (auto)</label><input style={S.inputLecture} value={fmt(calc.bovins_ressuage)} readOnly /></div>
              </div>
              <div style={S.totalLigne}><span>TOTAL BOVINS</span><span>{fmt(totalBovins)} FCFA</span></div>
              </div>
            </div>

            {/* OVINS */}
            <div style={S.carte}>
              <div style={S.titreCarte()}>🐑 OVINS — {form.type_jour}: Stab {t('ovin').tarif_stabulation} F/tête | Abattage {t('ovin').tarif_abattage} F/kg</div>
              <div style={S.carteBody}><div style={S.grille4}>
                <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="ovins_nbr" value={form.ovins_nbr} onChange={champ} /></div>
                <div><label style={S.label}>Poids (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="ovins_poids" value={form.ovins_poids} onChange={champ} /></div>
                <div><label style={S.label}>Stabulation (auto)</label><input style={S.inputLecture} value={fmt(calc.ovins_stab)} readOnly /></div>
                <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.ovins_abattage)} readOnly /></div>
              </div>
              <div style={S.totalLigne}><span>TOTAL OVINS</span><span>{fmt(totalOvins)} FCFA</span></div>
              </div>
            </div>

            {/* CAPRINS */}
            <div style={S.carte}>
              <div style={S.titreCarte()}>🐐 CAPRINS — {form.type_jour}: Stab {t('caprin').tarif_stabulation} F/tête | Abattage {t('caprin').tarif_abattage} F/kg</div>
              <div style={S.carteBody}><div style={S.grille4}>
                <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="caprins_nbr" value={form.caprins_nbr} onChange={champ} /></div>
                <div><label style={S.label}>Poids (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="caprins_poids" value={form.caprins_poids} onChange={champ} /></div>
                <div><label style={S.label}>Stabulation (auto)</label><input style={S.inputLecture} value={fmt(calc.caprins_stab)} readOnly /></div>
                <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.caprins_abattage)} readOnly /></div>
              </div>
              <div style={S.totalLigne}><span>TOTAL CAPRINS</span><span>{fmt(totalCaprins)} FCFA</span></div>
              </div>
            </div>

            {/* PORCINS */}
            <div style={S.carte}>
              <div style={S.titreCarte()}>🐖 PORCINS — {form.type_jour}: Stab {t('porcin').tarif_stabulation} F/tête | Abattage {t('porcin').tarif_abattage} F/kg</div>
              <div style={S.carteBody}><div style={S.grille4}>
                <div><label style={S.label}>Nombre de têtes</label><input style={S.input} type="number" min="0" name="porcins_nbr" value={form.porcins_nbr} onChange={champ} /></div>
                <div><label style={S.label}>Poids (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="porcins_poids" value={form.porcins_poids} onChange={champ} /></div>
                <div><label style={S.label}>Stabulation (auto)</label><input style={S.inputLecture} value={fmt(calc.porcins_stab)} readOnly /></div>
                <div><label style={S.label}>Abattage (auto)</label><input style={S.inputLecture} value={fmt(calc.porcins_abattage)} readOnly /></div>
              </div>
              <div style={S.totalLigne}><span>TOTAL PORCINS</span><span>{fmt(totalPorcins)} FCFA</span></div>
              </div>
            </div>

            {/* VIANDE FORAINE */}
            <div style={S.carte}>
              <div style={S.titreCarte()}>🥩 Viande Foraine</div>
              <div style={S.carteBody}><div style={S.grille3}>
                <div><label style={S.label}>Poids VF (kg)</label><input style={S.input} type="number" min="0" step="0.01" name="vf_poids" value={form.vf_poids} onChange={champ} /></div>
                <div><label style={S.label}>Tarif (FCFA/kg)</label><input style={S.input} type="number" min="0" step="0.01" name="vf_tarif" value={form.vf_tarif} onChange={champ} /></div>
                <div><label style={S.label}>Montant (auto)</label><input style={S.inputLecture} value={fmt(calc_vf)} readOnly /></div>
              </div>
              <div style={S.totalLigne}><span>TOTAL VIANDE FORAINE</span><span>{fmt(calc_vf)} FCFA</span></div>
              </div>
            </div>

            {/* ANNEXES */}
            <div style={S.carte}>
              <div style={S.titreCarte()}>💰 Prestations annexes</div>
              <div style={S.carteBody}><div style={S.grille4}>
                <div><label style={S.label}>Stockage frigo</label><input style={S.input} type="number" min="0" name="stockage_frigo" value={form.stockage_frigo} onChange={champ} /></div>
                <div><label style={S.label}>Stockage abattoir</label><input style={S.input} type="number" min="0" name="stockage_abattoir" value={form.stockage_abattoir} onChange={champ} /></div>
                <div><label style={S.label}>Location</label><input style={S.input} type="number" min="0" name="location" value={form.location} onChange={champ} /></div>
                <div><label style={S.label}>Timbres</label><input style={S.input} type="number" min="0" name="timbres" value={form.timbres} onChange={champ} /></div>
                <div><label style={S.label}>Tickets vendus</label><input style={S.input} type="number" min="0" name="tickets" value={form.tickets} onChange={champ} /></div>
                <div><label style={S.label}>N° Bon sortie</label><input style={S.input} type="text" name="bon_sortie_numero" value={form.bon_sortie_numero} onChange={champ} /></div>
                <div><label style={S.label}>Nb bons sortie</label><input style={S.input} type="number" min="0" name="bon_sortie_nombre" value={form.bon_sortie_nombre} onChange={champ} /></div>
              </div>
              </div>
            </div>

            <div style={S.carte}>
              <div style={S.titreCarte()}>📝 Observations</div>
              <div style={S.carteBody}><textarea style={{ width:'100%', padding:'9px 12px', border:`1.5px solid ${C.border}`, borderRadius:8, fontSize:14, height:80, resize:'vertical', boxSizing:'border-box' }} name="observations" value={form.observations} onChange={champ} /></div>
            </div>

            <div style={S.totalGeneral}>
              <span>💵 TOTAL GÉNÉRAL</span>
              <span style={{ fontSize:20, fontWeight:800 }}>{fmt(totalGeneral)} FCFA</span>
            </div>

            <button type="submit" style={{ background: estSigne ? '#C62828' : C.primary, color:'white', border:'none', padding:'14px 24px', borderRadius:8, fontSize:15, fontWeight:700, cursor:'pointer', width:'100%', marginTop:16, marginBottom:30 }} disabled={chargement}>
              {chargement ? '⏳ Sauvegarde...' : estSigne ? '🔑 SAUVEGARDER LA CORRECTION' : '💾 SAUVEGARDER LES MODIFICATIONS'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
